
import $ from "jquery"
import "bootstrap-transition"
import "bootstrap-modal"
import "bootstrap-modalmanager"
import {Page} from "app/multi_device"


const init_select2 = (selector = ".js-select2") => {
  // It could failed when multiple sign up modals exist
  try{
    $(selector).each((idx, el) => {
      const $el = $(el)
      const placeholder_text = $el.attr("placeholder")

      const select2_options: Select2.Options = {
        width:      "resolve",
        allowClear: true,
      }

      if (placeholder_text == null) {
        select2_options.placeholder = "Select an option..."
      }
      import(
        "select2/dist/js/select2.full"
      )
      .then(() => {
        $el.select2(select2_options)
      })
    })
  }
  catch (e){
    // do nothing
  }
}

const onLoad = () => {
  if (Page.isForMobile()) { return }

  init_select2()
  $("body").on("shown.bs.modal", () => {
    setTimeout(init_select2, 1000)
  })
}

export default {onLoad}


